import { DateUtils, ProgressSelectors, useTranslation } from '@web_opxp/features';
import React from 'react';
import { connect } from 'react-redux';
import ProgressCalendar from '../../components/ProgressCalendar/ProgressCalendar';
import { GroupSelectors } from '../../groupAdmin';
import { IState } from '../../store/state';

interface ICalendarSectionOwnProps {
  startTimestamp: number;
  endTimestamp: number;
  userId?: number;
  onNavigate: (startTimestamp: number) => void;
}

// narrow typing of progress data needed for calendar presentation
interface ICalendarEntry {
  timestamp: number;
}
type TCalendarProgress = ICalendarEntry[] | undefined | null;

interface ICalendarSectionParams extends ICalendarSectionOwnProps {
  progress: TCalendarProgress;
  userName?: string;
}

export const CalendarSectionFC: React.FC<ICalendarSectionParams> = ({
  startTimestamp,
  progress,
  userName,
  onNavigate,
}) => {
  const { language, t } = useTranslation();

  const loaded = !!progress && !!language;

  const workoutData = loaded
    ? progress.map((p) => {
        return {
          timestamp: DateUtils.unixToJsTimestamp(p.timestamp),
        };
      })
    : [];

  const userLabel = userName ? <p>{t('Evaluation.Overview.CalendarSection.Description', { user: userName })}</p> : null;
  return (
    <div className="calendar-section">
      <h3 className="calendar-section-title">{t('Evaluation.Overview.CalendarSection.Title')}</h3>
      {userLabel}
      <ProgressCalendar data={workoutData} startTimestamp={startTimestamp} onNavigate={onNavigate} />
    </div>
  );
};

const mapStateToProps = (state: IState, { startTimestamp, endTimestamp, userId }: ICalendarSectionOwnProps) => {
  const progress = ProgressSelectors.getProgressHistoryFromTimestamp(
    state,
    DateUtils.getUnixTimestamp(startTimestamp),
    DateUtils.getUnixTimestamp(endTimestamp),
    userId
  );
  const userName = userId ? GroupSelectors.getGroupMemberName(state, userId) : undefined;

  return {
    progress,
    userName,
  };
};

const CalendarSection = connect(mapStateToProps)(CalendarSectionFC);
export default CalendarSection;
